import { render, staticRenderFns } from "./ServiceCostReportPrint.vue?vue&type=template&id=78465b35&scoped=true&"
import script from "./ServiceCostReportPrint.vue?vue&type=script&lang=js&"
export * from "./ServiceCostReportPrint.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCostReportPrint.vue?vue&type=style&index=0&id=78465b35&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78465b35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
